import { useLanguage } from "../context/LanguageContext";
import { Button } from "./ui/button";
import { Globe } from "lucide-react";

const LanguageSelector = ({ variant = "default", showLabel = true }) => {
  const { language, toggleLanguage } = useLanguage();

  if (variant === "minimal") {
    return (
      <button
        onClick={toggleLanguage}
        className="flex items-center gap-1 text-sm text-gray-400 hover:text-white transition-colors"
        title={language === 'en' ? 'Cambiar a Español' : 'Switch to English'}
      >
        <Globe size={16} />
        <span className="uppercase font-medium">{language}</span>
      </button>
    );
  }

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={toggleLanguage}
      className="border-white/15 text-platinum hover:bg-white/5 hover:text-gold font-semibold"
      title={language === 'en' ? 'Cambiar a Español' : 'Switch to English'}
    >
      <Globe size={16} className="mr-2" />
      {showLabel && (
        <span>{language === 'en' ? 'Español' : 'English'}</span>
      )}
      {!showLabel && (
        <span className="uppercase">{language}</span>
      )}
    </Button>
  );
};

export default LanguageSelector;
